const ActionType = {
  GET_QUESTIONS: 'frequently-asked-questions/get-questions',
}

export default ActionType
